import { createClient, type ClusterUrl } from '@solana/kit';
import { solanaRpc } from '@solana/kit-plugin-rpc';
import { walletSigner } from '@solana/kit-plugin-wallet';
import type { SolanaCluster } from './config';

export function createBlackBtcClient(rpcUrl: string, cluster: SolanaCluster) {
  return createClient()
    .use(walletSigner({
      chain: cluster === 'devnet' ? 'solana:devnet' : 'solana:mainnet',
      storageKey: `black-btc-wallet.${cluster}`,
    }))
    .use(solanaRpc({
      rpcUrl: rpcUrl as ClusterUrl,
      skipPreflight: false,
    }));
}

export type BlackBtcClient = ReturnType<typeof createBlackBtcClient>;


